"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrow_down = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const arrow_down = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'arrow-down-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M10.5303 16.5303C10.2374 16.8232 9.76256 16.8232 9.46967 16.5303L4.6967 11.7574C4.4038 11.4645 4.4038 10.9896 4.6967 10.6967C4.98959 10.4038 5.46446 10.4038 5.75736 10.6967L9.25 14.1893L9.25 4C9.25 3.58579 9.58578 3.25 10 3.25C10.4142 3.25 10.75 3.58579 10.75 4L10.75 14.1893L14.2426 10.6967C14.5355 10.4038 15.0104 10.4038 15.3033 10.6967C15.5962 10.9896 15.5962 11.4645 15.3033 11.7574L10.5303 16.5303Z', fill: '#4B5563' })));
};
exports.arrow_down = arrow_down;
